import React, { FC } from "react";
import css from "./SearchInput.module.scss";
import { ReactComponent as SearchIcon } from "Assets/searchIcon.svg";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";

type Props = TextFieldProps;
const SearchInput: FC<Props> = ({ ...props }) => {
  return (
    <div className={css.boxInput}>
      <TextField
        className={css.boxInput__input}
        placeholder="Search"
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon cursor="pointer" className={css.boxInput__icon} />
            </InputAdornment>
          ),
        }}
        {...props}
      />
    </div>
  );
};

export default SearchInput;
